import React from 'react';
import './TaskComponent.css';

interface TaskComponentProps {
  className?: string;
  htmlDescription?: string;
}

const TaskComponent: React.FC<TaskComponentProps> = ({ className, htmlDescription }) => {
  return (
    <div className={`task-component ${className || ''}`}>
      <h2>Opdracht</h2>
      <div className="task-content">
        {htmlDescription ? (
          <div dangerouslySetInnerHTML={{ __html: htmlDescription }} />
        ) : (
          <>
            <p>Je werkt in het station. Iemand vraagt jou om de weg.<br/> Gebruik de volgende informatie:</p>
            <img src="/assets/train-schedule.jpg" alt="Treinschema" />
          </>
        )}
      </div>
    </div>
  );
};

export default TaskComponent;